

import { createUseStyles } from 'react-jss';
import colors from "../../utils/colors";

var styles = {
  header: function header(_ref) {var customMainColor = _ref.customMainColor;return {
      letterSpacing: '0.02rem',
      color: customMainColor || colors.neutral[900],
      maxHeight: '6.5rem',
      position: 'relative', // for box-shadow to be displayed
      zIndex: '11',

      '@media(max-width:1024px)': {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%'
      }
    };},
  mobileHomeLink: {
    textDecoration: 'none',
    color: 'inherit'
  },
  link: function link(_ref2) {var customMainColor = _ref2.customMainColor;return {
      color: customMainColor || colors.neutral[900],
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    };},
  desktopHeaderWrapper: function desktopHeaderWrapper() {return {
      display: 'flex',
      alignItems: 'center',
      height: '6.4rem',
      boxShadow: '4px 7px 4px -4px rgba(0, 0, 0, 0.16)',
      backgroundColor: colors.neutral.white
    };},
  mobileHeaderWrapper: function mobileHeaderWrapper(_ref3) {var customMainColor = _ref3.customMainColor;return {
      backgroundColor: colors.neutral.white,
      color: customMainColor || colors.neutral[700],
      boxShadow: '4px 7px 4px -4px rgba(0, 0, 0, 0.16)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 2.4rem',
      boxSizing: 'border-box',
      height: '6.4rem',
      position: 'fixed',
      width: '100vw',
      top: 0
    };},

  // Mobile media
  '@media(min-width:1025px)': {
    // MAKE IT ONLY AS FUNCTION, DUE TO React-JSS media-queries bug!!!
    mobileHeaderWrapper: function mobileHeaderWrapper(_ref4) {var showDevTools = _ref4.showDevTools;return {
        display: showDevTools ? 'flex' : 'none'
      };}
  },
  '@media(min-width:1441px)': {
    // MAKE IT ONLY AS FUNCTION, DUE TO React-JSS media-queries bug!!!
    mobileHeaderWrapper: function mobileHeaderWrapper() {return {
        display: 'none'
      };}
  },

  // Desktop media
  '@media(max-width:1440px)': {
    desktopHeaderWrapper: function desktopHeaderWrapper(_ref5) {var showDevTools = _ref5.showDevTools;return {
        display: showDevTools ? 'none' : 'flex'
      };}
  },
  '@media(max-width:1024px)': {
    desktopHeaderWrapper: function desktopHeaderWrapper() {return {
        display: 'none'
      };}
  },

  mobileScreenLogoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  mobileScreenLogo: {
    width: '35rem',
    maxHeight: '5.2rem',
    '@media(max-width: 450px)': {
      width: '70%',
      margin: '0 auto'
    }
  },
  baseSection: {
    display: 'flex',
    alignItems: 'center',
    width: '77%',
    padding: '0.6rem 0rem',
    boxSizing: 'border-box',
    height: '100%',
    '@media(max-width:1240px)': {
      width: '70%'
    }
  },
  headerLogoWrapper: function headerLogoWrapper(_ref6) {var customMainColor = _ref6.customMainColor;return {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      padding: {
        right: '2.4rem',
        left: '2.4rem'
      },
      borderRight: "0.1rem solid ".concat(customMainColor || colors.neutral[900])
    };},
  desktopScreenLogo: {
    maxHeight: '5.2rem',
    width: '35rem'
  },
  navigation: {
    display: 'flex',
    flexGrow: 2,
    justifyContent: 'space-between'
  },
  pagesLinksBlock: {
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    paddingLeft: '4.3rem'
  },
  pageLink: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '4rem',
    '&:last-of-type': {
      marginRight: '0rem'
    }
  },
  pageLinkText: {
    marginLeft: '1.3rem',
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 700
    }
  },
  additionalLinksBlock: {
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    padding: {
      right: '2.6rem'
    }
  },
  additionalLinksItem: {
    display: 'flex',
    alignItems: 'center'
  },
  userAccountSection: {
    boxSizing: 'border-box'
  }
};
var createStyles = createUseStyles(styles);

export { createStyles };
//# sourceMappingURL=styles.js.map